import * as React from "react";
import Typograpy from "../Typography";

const KycStatus = ({ kycStatus }: { kycStatus: string | undefined }) => {
  const getStatusBg = (kycStatus: string | undefined) => {
    switch (kycStatus) {
      case "Verified":
        return {
          bg: "#E1FCEF",
          br: "#004004",
        };
      case "In Progress":
        return {
          bg: "#FFF3E9",
          br: "#DF6F07",
        };
      case "Failed":
        return {
          bg: "#FFF3F3",
          br: "#A90B0B",
        };
      case "Link Sent":
        return {
          bg: "#F1F6FF",
          br: "#0057FF",
        };
      default:
        break;
    }
  };

  return (
    <div
      className={`flex justify-center items-center py-2 px-3 gap-2 rounded-lg w-fit`}
      style={{
        background: `${getStatusBg(kycStatus)?.bg}`,
      }}
    >
      <div
        className={`rounded-full w-2 h-2`}
        style={{
          backgroundColor: `${getStatusBg(kycStatus)?.br}`,
        }}
      />
      <Typograpy
        className={`text-xs font-semibold`}
        tagType="p"
        fontStyle={{
          fontColor: `${getStatusBg(kycStatus)?.br}`,
        }}
        text={kycStatus}
      />
    </div>
  );
};

export default KycStatus;
